export default __webpack_public_path__ + "static/media/img4.db83f35a.jpg";